import React from "react";
import { Panel } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./settings.css";

function Settings(props) {
  let user = props.user || {};

  return (
    <div className="settings">
      <h3>Manage Account</h3>
      <Panel>
        <Panel.Heading>Account Information</Panel.Heading>
        <Panel.Body>
          <div>
            <b>First Name:</b> {user.first_name}
          </div>
          <div>
            <b>Last Name:</b> {user.last_name}
          </div>
          <div>
            <b>Street Address 1:</b> {user.address}
          </div>
          <div>
            <b>Street Address 2:</b> {user.address2}
          </div>
          <div>
            <b>City:</b> {user.city}
          </div>
          <div>
            <b>State:</b> {user.state}
          </div>
          <div>
            <b>Zip:</b> {user.zip_code}
          </div>
          <br />
          <Link to={"/update-password"}>Change Password</Link>
        </Panel.Body>
      </Panel>
    </div>
  );
}

export default Settings;



// WEBPACK FOOTER //
// ./src/account/components/settings.js